import { render, staticRenderFns } from "./time_table.vue?vue&type=template&id=1ffbaa90&scoped=true&"
import script from "./time_table.vue?vue&type=script&lang=js&"
export * from "./time_table.vue?vue&type=script&lang=js&"
import style0 from "./time_table.vue?vue&type=style&index=0&id=1ffbaa90&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffbaa90",
  null
  
)

export default component.exports